var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "26px",
    viewBox: "0 0 24 24",
    width: "26px",
    fill: "#484888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 9,
    x: 13,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 9,
    x: 13,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 6,
    x: 16,
    y: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13,12 8,7 8,11 2,11 2,13 8,13 8,17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.84c28348a0db9d5a49eaebdaebc24036.svg";
export { ForwardRef as ReactComponent };